import React from 'react';
import LedgerReport from './Ledger_Report';
import '../../../CommonCSS/SocietyCSS.css'

const LedgerApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Ledger Report</h5>
          </div>
        </div>
        <LedgerReport />
      </div>
    </div >
  );
};

export default LedgerApp;
